import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-retrive-account",
  templateUrl: "./retrive-account.component.html",
  styleUrls: ["./retrive-account.component.css"],
})
export class RetriveAccountComponent implements OnInit {
  constructor(private matDialogref: MatDialogRef<RetriveAccountComponent>) {}

  ngOnInit(): void {}
  clear() {
    this.matDialogref.close();
  }
}
